import SiteNavigation from './SiteNavigation';

const siteNavigationConfig = {
  name: 'siteNavigation',
  class: SiteNavigation,
  querySelectorAll: {
    menuItemParents: '.site-nav__menu-item--has-children',
  },
  options: {
    stickyClass: 'site-nav--sticky',
    subNavActiveClass: 'site-nav__menu-item--subnav-active',
    // Headroom.js config
    // @ref: http://wicky.nillia.ms/headroom.js/
    headroom: {
      // vertical offset in px before element is first unpinned
      offset: 300,
      // scroll tolerance in px before state changes
      tolerance: 5,
      // css classes to apply
      classes: {
        // when element is initialised
        initial: 'site-nav',
        // when scrolling down
        pinned: 'site-nav--slidedown',
        // when scrolling up
        unpinned: 'site-nav--slideup',
        // when above offset
        top: 'site-nav--top',
        // when below offset
        notTop: 'site-nav--not-top',
        // when at bottom of scoll area
        bottom: 'site-nav--bottom',
        // when not at bottom of scroll area
        notBottom: 'site-nav--not-bottom',
      },
    },
  },
};

export default siteNavigationConfig;



// WEBPACK FOOTER //
// ./client/js/components/Header/siteNavigationConfig.js